import Events from "actions/events";
// Refactor Client Name out eventually
const ProductionListReducer = (state = [], action) => {
  switch (action.type) {
  	case Events.Productions.REQUEST:
      return Object.assign({}, state, {
    	  isLoading:true
    	  })
    case Events.Productions.RECEIVE:
      return Object.assign({}, state, {
    	  isLoading:false,
    	  productions: action.data.productions,
        clientName: action.data.clientName
    	  })
    default:
      return state
  }
}

export default ProductionListReducer;



// WEBPACK FOOTER //
// ./src/scripts/reducers/ProductionListReducer.js